import React from 'react';

// Utility component for fixing spacing issues
export const SpacingFix = ({ children, className = '', type = 'normal' }) => {
  const spacingClasses = {
    compact: 'compact',
    normal: 'normal-spacing',
    relaxed: 'relaxed-spacing',
    none: 'no-margin no-padding'
  };

  return (
    <div className={`${spacingClasses[type]} ${className}`}>
      {children}
    </div>
  );
};

// Utility function to clean WordPress content and markdown
export const cleanWordPressSpacing = (content) => {
  if (!content) return '';
  
  return content
    // Remove executable or embedded content from WordPress before rendering.
    .replace(/<\/?(script|style|iframe|object|embed|form)[^>]*>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/\son[a-z]+\s*=\s*(["']).*?\1/gi, '')
    .replace(/\s(href|src)\s*=\s*(["'])\s*javascript:[\s\S]*?\2/gi, '')
    // Remove problematic inline styles and attributes
    .replace(/style="[^"]*"/gi, '') // Remove all style attributes
    .replace(/superb-addons-animation="[^"]*"/gi, '') // Remove animation attributes
    .replace(/class="[^"]*wp-block[^"]*"/gi, '') // Remove WordPress block classes
    .replace(/class="[^"]*"/gi, '') // Remove all class attributes
    .replace(/id="[^"]*"/gi, '') // Remove all id attributes
    .replace(/data-[^=]*="[^"]*"/gi, '') // Remove all data attributes
    
    // Clean up HTML entities
    .replace(/&#8217;/g, "'") // Convert apostrophe entity
    .replace(/&#8216;/g, "'") // Convert left single quote entity
    .replace(/&quot;/g, '"') // Convert quote entities
    .replace(/&amp;/g, '&') // Convert ampersand entity
    .replace(/&lt;/g, '<') // Convert less than entity
    .replace(/&gt;/g, '>') // Convert greater than entity
    .replace(/&nbsp;/g, ' ') // Convert non-breaking space
    
    // Clean up excessive whitespace — preserve newlines (critical for markdown)
    .replace(/\n{3,}/g, '\n\n') // Collapse 3+ blank lines to 2
    .replace(/[ \t]+$/gm, '') // Remove trailing spaces per line (not newlines)
    .replace(/^[ \t]+/gm, '') // Remove leading spaces per line (not newlines)
    .replace(/>\s+</g, '><') // Remove whitespace between HTML tags only
    .replace(/[^\S\n]+/g, ' ') // Normalize spaces/tabs but KEEP newlines
    
    // Remove empty elements
    .replace(/<p>\s*<\/p>/gi, '')
    .replace(/<div>\s*<\/div>/gi, '')
    .replace(/<span>\s*<\/span>/gi, '')
    
    // Remove WordPress-specific comments and blocks
    .replace(/<!--\s*\/?wp:.*?-->/g, '')
    .replace(/<div[^>]*class="[^"]*wp-block[^"]*"[^>]*>.*?<\/div>/gs, '')
    
    // Clean up line breaks
    .replace(/\s*<br\s*\/?>\s*/gi, ' ')
    .replace(/\s*<br\s*\/?>\s*<br\s*\/?>\s*/gi, '\n\n')
    
    .trim();
};

// CSS classes for common spacing fixes
export const spacingClasses = {
  // Remove all spacing
  noSpacing: 'no-margin no-padding',
  
  // Compact spacing
  compact: 'compact',
  
  // Normal spacing
  normal: 'normal-spacing',
  
  // Relaxed spacing
  relaxed: 'relaxed-spacing',
  
  // Blog content specific
  blogContent: 'blog-content',
  
  // Product specific
  productCard: 'product-card',
  productSection: 'product-section',
  
  // Section specific
  contentSection: 'content-section',
  blogPostHeader: 'blog-post-header',
  
  // Grid specific
  productsGrid: 'products-grid',
};

export default SpacingFix; 
